import React, { useState, useEffect, useRef } from "react";
import FooterButtons from "components/FooterButtons";
import LinkButton from "components/LinkButton";
import PrimaryButton from "components/PrimaryButton";
import AuthorInfo from "components/AuthorInfo";
import RightPane from "./RightPane";
import CircularProgressBar from "Uitls/CircularProgressBar";
import { useKeycloak } from "@react-keycloak/web";
import {
  createModule,
  updateModule,
  getLanguageForCountry,
  getSubTopics,
  getSegmentList,
  getDraftElementsList,
  getStrategicObjectivesForBrand,
  getAgencyList,
  getAudienceList,
  getIndicationsListFromApi,
  getTherapeuticAreaList,
  getContentToneList,
} from "services/apis";
import { showError } from "Uitls/Util";
import styled from "styled-components";
import variables from "styles/base/_universal.scss";
import infoIcon from "img/infoicon2.svg";
import OverlayPopOverToolTip from "Uitls/OverlayPopOverToolTip";
import {
  getIndicationDataForSave,
  getSegmentDataForSave,
  getDraftElementsDataForSave,
  getStrategiDataForSave,
} from "Uitls/Util";

const MetaDataInformation = ({
  closeMetaDataScreen,
  gotoNextPage,
  editMetaDataFlag,
  metaDataDropDownList,
  buttonLable,
  module,
  moduleType,
  setOpenCopy,
  setUpdatedMetadata,
}) => {
  const { keycloak } = useKeycloak();
  const userName = !!keycloak.authenticated ? keycloak.tokenParsed.name : null;
  const [metadata, setMetadata] = useState({
    source: "PromoMats",
  });
  const [isloading, setIsloading] = useState(false);
  //const { module } = useContext(ModuleContext);
  const [languageForCOuntry, setLanguageForCOuntry] = useState([]);
  const [subTopics, setSubTopics] = useState([]);
  const [segmentList, setSegmentList] = useState([]);
  const [draftElementsList, setDraftElementsList] = useState([]);
  const [strategicobjList, setStrategicobjList] = useState([]);
  const [agencyList, setAgencyList] = useState([]);
  const [contentToneList, setContentToneList] = useState([]);
  const [audienceList, setAudienceList] = useState([]);
  const [indicationList, setIndicationList] = useState([]);
  const [therapeuticAreaList, setTherapeuticAreaList] = useState([]);
  const [isDirty, setIsDirty] = useState(false);
  const initialMetadataRef = useRef(null);
  // console.log("moduleType", moduleType);

  /**
   * Clone module and go to next page
   */

  const cloneModuleAndGoToNextPage = () => {
    setUpdatedMetadata(metadata);
    setOpenCopy();
  };

  /**
   * Creates payload for creating/cloning a module
   */
  const createModulePayload = () => {
    const strategicObject = [];

    // if (metadata?.strategicobj?.displayName) {
    //   strategicObject.push({
    //     strategicObjDamId: metadata?.strategicobj?.veevaId || undefined,
    //     strategicObjName: metadata?.strategicobj?.displayName || undefined,
    //   });
    // }
    if (metadata?.strategicobj && metadata.strategicobj.length > 0) {
      strategicObject.push(
        ...metadata.strategicobj.map((item) => ({
          strategicObjDamId: item.veevaId || undefined,
          strategicObjName: item.displayName || undefined,
        })),
      );
    }
    const payload = {
      source: metadata?.source,
      productDamId: metadata?.brand?.veevaId,
      productName: metadata?.brand?.displayName,
      countryDamId: metadata?.country?.veevaId,
      countryName: metadata?.country?.displayName,
      topicDamId: metadata?.topic?.veevaId,
      topicName: metadata?.topic?.displayName,
      subtopicDamId: metadata?.subtopic?.veevaId,
      subtopicName: metadata?.subtopic?.displayName,
      communicationObjectives: metadata?.communicationObjectives || "",
      brandStyleGuidelines: metadata?.styleGuidelines || "",
      createdByName: userName,
      moduleName: metadata?.moduleName,
      languageDamId: metadata?.language?.veevaId,
      languageName: metadata?.language?.displayName,
      therapeuticAreaDamId: metadata?.theraupaticArea?.veevaId,
      therapeuticAreaName: metadata?.theraupaticArea?.displayName,
      audienceDamId: metadata?.audience?.veevaId,
      audienceName: metadata?.audience?.displayName,
      strategicObjectives: strategicObject,
      segments: getSegmentDataForSave(metadata?.segment),
      indications: getIndicationDataForSave(metadata?.indication),
      draftElementIncluded: getDraftElementsDataForSave(
        metadata?.draftElementIncluded,
      ),
      creativeAgencyName: metadata?.agency?.displayName,
      creativeAgencyDamId: metadata?.agency?.veevaId,
      contentToneName: metadata?.contentTone?.displayName,
      contentToneDamId: metadata?.contentTone?.veevaId,
    };
    return payload;
  };
  /**
   * Create module and go to the Assemble module screen
   */
  const createModuleAndGoToNextPage = () => {
    const payload = createModulePayload();
    setIsloading(true);
    createModule(payload, (res, err) => {
      setIsloading(false);
      if (res) {
        gotoNextPage(res.data);
        return;
      }
      showError(err);
    });
  };

  /**
   * Validate if the mandarory fields are added in metadata
   * @returns true/false
   */
  const checkForEditMetadata = () => {
    if (moduleType === "cloned") {
      return true;
    }
    // return (
    //   module?.claims?.length !== 0 ||
    //   module?.components?.length !== 0 ||
    //   module?.reusableTexts?.length !== 0
    // );
  };

  const validateMetaDataSelection = () => {
    let allFilled = false;
    if (moduleType !== "cloned" && editMetaDataFlag && checkForEditMetadata()) {
      return false;
    } else {
      allFilled =
        metadata?.brand &&
        metadata?.moduleName?.trim() &&
        metadata?.country &&
        metadata?.topic &&
        metadata?.language &&
        metadata?.communicationObjectives &&
        metadata?.communicationObjectives !== "" &&
        // metadata?.subtopic &&
        metadata?.audience &&
        metadata?.segment?.length > 0 &&
        //metadata?.contentTone &&
        metadata?.agency &&
        //metadata?.indication?.length > 0 &&
        (metadata?.country?.veevaId !== "unitedStates" ||
          metadata?.draftElementIncluded?.length > 0) &&
        metadata?.theraupaticArea;
      return allFilled;
    }
  };

  const primaryButton = (
    <PrimaryButton
      title={buttonLable.toUpperCase()}
      customIcon={
        isDirty && buttonLable === "Update module" ? ( // show icon ONLY when metadata changed
          <OverlayPopOverToolTip
            element={
              <IconWrapper>
                <img src={infoIcon} alt="Information" />
              </IconWrapper>
            }
            overlayData={
              <ToolTipText>
                <strong>Republish the module</strong>
                <br />
                to ensure the metadata
                <br />
                is updated
              </ToolTipText>
            }
            trigger={["hover", "focus"]}
            placement="top"
            classId="tooltip"
            useCustomPopper={true}
          />
        ) : null
      }
      handleClick={() => {
        if (moduleType !== "cloned" && editMetaDataFlag) {
          updateMetaDataAndCloseModal();
        } else if (moduleType === "cloned") {
          cloneModuleAndGoToNextPage();
        } else {
          createModuleAndGoToNextPage();
        }
      }}
      disabled={
        !validateMetaDataSelection() ||
        (moduleType !== "cloned" &&
          module?.mlrStatus &&
          module?.mlrStatus.toLowerCase() === "available for use")
      }
      isFlex={buttonLable === "Update module"}
    />
  );

  const CancelButton = (
    <LinkButton
      title={"Cancel".toUpperCase()}
      handleClick={closeMetaDataScreen}
    />
  );
  // Helper function to compare values
  const compareValues = (newValue, oldValue) => {
    // Handle null/undefined
    if (!newValue && !oldValue) return true;
    if (!newValue || !oldValue) return false;
    if (typeof newValue === "string" && typeof oldValue === "string") {
      return newValue.trim() === oldValue.trim();
    }

    // Handle arrays
    if (Array.isArray(newValue) && Array.isArray(oldValue)) {
      if (newValue.length !== oldValue.length) return false;
      const newIds = newValue
        .map((item) => item?.veevaId || item)
        .sort()
        .join(",");
      const oldIds = oldValue
        .map((item) => item?.veevaId || item)
        .sort()
        .join(",");
      return newIds === oldIds;
    }

    // Handle objects with veevaId
    if (typeof newValue === "object" && typeof oldValue === "object") {
      return (
        (newValue?.veevaId || newValue) === (oldValue?.veevaId || oldValue)
      );
    }

    // Handle primitives
    return String(newValue || "") === String(oldValue || "");
  };

  const handleDropdownSelection = (value, type) => {
    // Map type to metadata key (handle special case for 'market')
    const metadataKey = type === "market" ? "country" : type;

    // Check if value changed from initial
    if (editMetaDataFlag && initialMetadataRef.current) {
      const initialValue = initialMetadataRef.current[metadataKey];
      setIsDirty(!compareValues(value, initialValue));
    }

    // Define fields that should be reset when certain fields change
    const resetRules = {
      brand: { segment: null, strategicobj: null },
      market: { language: null, segment: null, draftElementIncluded: [] },
      topic: { subtopic: null },
    };

    // Update metadata
    setMetadata((prevState) => ({
      ...prevState,
      [metadataKey]: value,
      ...(resetRules[type] || {}),
    }));
  };

  // const handleDropdownSelection = (value, type) => {
  //   // Only set dirty if the new value is different from initial value
  //   if (editMetaDataFlag && initialMetadataRef.current) {
  //     let initialValue;
  //     switch (type) {
  //       case "brand":
  //         initialValue = initialMetadataRef.current.brand;
  //         break;
  //       case "market":
  //         initialValue = initialMetadataRef.current.country;
  //         break;
  //       case "topic":
  //         initialValue = initialMetadataRef.current.topic;
  //         break;
  //       case "subtopic":
  //         initialValue = initialMetadataRef.current.subtopic;
  //         break;
  //       case "communicationObjectives":
  //         initialValue = initialMetadataRef.current.communicationObjectives;
  //         break;
  //       case "styleGuidelines":
  //         initialValue = initialMetadataRef.current.styleGuidelines;
  //         break;
  //       case "segment":
  //         initialValue = initialMetadataRef.current.segment;
  //         break;
  //       case "indication":
  //         initialValue = initialMetadataRef.current.indication;
  //         break;
  //       case "language":
  //         initialValue = initialMetadataRef.current.language;
  //         break;
  //       case "audience":
  //         initialValue = initialMetadataRef.current.audience;
  //         break;
  //       case "theraupaticArea":
  //         initialValue = initialMetadataRef.current.theraupaticArea;
  //         break;
  //       case "strategicobj":
  //         initialValue = initialMetadataRef.current.strategicobj;
  //         break;
  //       case "moduleName":
  //         initialValue = initialMetadataRef.current.moduleName;
  //         break;
  //       case "draftElementIncluded":
  //         initialValue = initialMetadataRef.current.draftElementIncluded;
  //         break;
  //       case "agency":
  //         initialValue = initialMetadataRef.current.agency;
  //         break;
  //       case "contentTone":
  //         initialValue = initialMetadataRef.current.contentTone;
  //         break;
  //       default:
  //         initialValue = null;
  //     }

  //     // Only set dirty if values are different
  //     if (!compareValues(value, initialValue)) {
  //       setIsDirty(true);
  //     } else if (compareValues(value, initialValue)) {
  //       setIsDirty(false);
  //     }
  //   }

  //   switch (type) {
  //     case "brand":
  //       setMetadata((prevState) => {
  //         return {
  //           ...prevState,
  //           brand: value,
  //           segment: null,
  //           strategicobj: null,
  //         };
  //       });
  //       break;
  //     case "market":
  //       setMetadata((prevState) => {
  //         return {
  //           ...prevState,
  //           country: value,
  //           language: null,
  //           segment: null,
  //           draftElementIncluded: [],
  //         };
  //       });
  //       break;

  //     case "topic":
  //       setMetadata((prevState) => {
  //         return { ...prevState, topic: value, subtopic: null };
  //       });
  //       break;
  //     case "subtopic":
  //       setMetadata((prevState) => {
  //         return { ...prevState, subtopic: value };
  //       });
  //       break;
  //     case "communicationObjectives":
  //       setMetadata((prevState) => {
  //         return { ...prevState, communicationObjectives: value };
  //       });
  //       break;
  //     case "styleGuidelines":
  //       setMetadata((prevState) => {
  //         return { ...prevState, styleGuidelines: value };
  //       });
  //       break;
  //     case "segment":
  //       setMetadata((prevState) => {
  //         return { ...prevState, segment: value };
  //       });
  //       break;
  //     case "indication":
  //       setMetadata((prevState) => {
  //         return { ...prevState, indication: value };
  //       });
  //       break;
  //     case "language":
  //       setMetadata((prevState) => {
  //         return { ...prevState, language: value };
  //       });
  //       break;
  //     case "audience":
  //       setMetadata((prevState) => {
  //         return { ...prevState, audience: value };
  //       });
  //       break;
  //     case "theraupaticArea":
  //       setMetadata((prevState) => {
  //         return { ...prevState, theraupaticArea: value };
  //       });
  //       break;
  //     case "strategicobj":
  //       setMetadata((prevState) => {
  //         return { ...prevState, strategicobj: value };
  //       });
  //       break;
  //     case "moduleName":
  //       setMetadata((prevState) => {
  //         return { ...prevState, moduleName: value };
  //       });
  //       break;
  //     case "draftElementIncluded":
  //       setMetadata((prevState) => {
  //         return { ...prevState, draftElementIncluded: value };
  //       });
  //       break;
  //     case "agency":
  //       setMetadata((prevState) => {
  //         return { ...prevState, agency: value };
  //       });
  //       break;
  //     case "contentTone":
  //       setMetadata((prevState) => {
  //         return { ...prevState, contentTone: value };
  //       });
  //       break;
  //     default:
  //       break;
  //   }
  // };
  const updateMetaDataAndCloseModal = () => {
    const strategicObject = [];
    if (metadata?.strategicobj?.displayName) {
      strategicObject.push({
        strategicObjDamId: metadata?.strategicobj?.veevaId || undefined,
        strategicObjName: metadata?.strategicobj?.displayName || undefined,
      });
    }
    const payload = {
      countryDamId: metadata?.country?.veevaId,
      countryName: metadata?.country?.displayName,
      topicDamId: metadata?.topic?.veevaId,
      topicName: metadata?.topic?.displayName,
      subtopicDamId: metadata?.subtopic?.veevaId || "",
      subtopicName: metadata?.subtopic?.displayName || "",
      communicationObjectives: metadata?.communicationObjectives || "",
      brandStyleGuidelines: metadata?.styleGuidelines || "",
      moduleName: metadata?.moduleName.trim(),
      languageDamId: metadata?.language?.veevaId,
      languageName: metadata?.language?.displayName,
      therapeuticAreaDamId: metadata?.theraupaticArea?.veevaId,
      therapeuticAreaName: metadata?.theraupaticArea?.displayName,
      audienceDamId: metadata?.audience?.veevaId,
      audienceName: metadata?.audience?.displayName,
      strategicObjectives: getStrategiDataForSave(metadata?.strategicobj),
      segments: getSegmentDataForSave(metadata?.segment),
      indications: getIndicationDataForSave(metadata?.indication),
      draftElementIncluded: getDraftElementsDataForSave(
        metadata?.draftElementIncluded,
      ),
      editedByName: userName,
      creativeAgencyName: metadata?.agency?.displayName,
      creativeAgencyDamId: metadata?.agency?.veevaId,
      contentToneName: metadata?.contentTone?.displayName,
      contentToneDamId: metadata?.contentTone?.veevaId,
    };

    setIsloading(true);
    updateModule(payload, module?.moduleId, (res, err) => {
      setIsloading(false);
      if (res) {
        gotoNextPage();
        return;
      }
      showError(err);
    });
  };

  useEffect(() => {
    if (metadata?.country?.veevaId) {
      getLanguagesForSelectedCountry();
    }
  }, [metadata?.country?.veevaId]);

  const getLanguagesForSelectedCountry = () => {
    setIsloading(true);
    getLanguageForCountry(metadata?.country?.veevaId, (res, err) => {
      setIsloading(false);
      if (res) {
        setLanguageForCOuntry(res.data);
        return;
      }
      showError(err);
    });
  };
  useEffect(() => {
    handleDropdownSelection(undefined, "subtopic");
    if (metadata?.topic?.veevaId && metadata?.brand?.veevaId) {
      getSubTopicsData(metadata?.brand?.veevaId, metadata?.topic?.veevaId);
    }
  }, [metadata?.topic?.veevaId, metadata?.brand?.veevaId]);

  const getSubTopicsData = (productDamId, topicDamId) => {
    const payload = {
      productDamIds: [productDamId],
      topicDamIds: [topicDamId],
    };
    setIsloading(true);
    getSubTopics(payload, (res, err) => {
      setIsloading(false);
      if (res) {
        setSubTopics(res.data);
        return;
      }
      showError(err);
    });
  };
  useEffect(() => {
    if (metadata?.country?.veevaId && metadata?.brand?.veevaId) {
      getSegmentData(metadata?.brand?.veevaId, metadata?.country?.veevaId);
    }
  }, [metadata?.country?.veevaId, metadata?.brand?.veevaId]);
  useEffect(() => {
    if (metadata?.country?.veevaId) {
      if (metadata?.country?.veevaId === "unitedStates") {
        getDraftElementsData();
      }
    }
  }, [metadata?.country?.veevaId]);
  const getSegmentData = (productDamId, countryDamId) => {
    setIsloading(true);
    getSegmentList(productDamId, countryDamId, (res, err) => {
      setIsloading(false);
      if (res) {
        setSegmentList(res.data);
        return;
      }
      showError(err);
    });
  };
  const getDraftElementsData = () => {
    setIsloading(true);
    getDraftElementsList((res, err) => {
      setIsloading(false);
      if (res) {
        setDraftElementsList(res.data);
        return;
      }
      showError(err);
    });
  };
  useEffect(() => {
    if (metadata?.brand?.veevaId) {
      getStrategicObjectivesList();
    }
  }, [metadata?.brand?.veevaId]);

  const getStrategicObjectivesList = () => {
    setIsloading(true);
    getStrategicObjectivesForBrand(metadata?.brand?.veevaId, (res, err) => {
      setIsloading(false);
      if (res) {
        setStrategicobjList(res.data);
        return;
      }
      showError(err);
    });
  };
  useEffect(() => {
    getAgency();
    getAudienceMetadata();
    getIndicatiosMetaData();
    getTherapeuticMetaData();
  }, []);
  const getAgency = () => {
    setIsloading(true);
    getAgencyList((res, err) => {
      setIsloading(false);
      if (res) {
        setAgencyList(res.data);
        return;
      }
      showError(err);
    });
  };

  const getContentTone = () => {
    setIsloading(true);
    getContentToneList(metadata?.brand?.veevaId, (res, err) => {
      setIsloading(false);
      if (res) {
        setContentToneList(res.data);
        return;
      }
      showError(err);
    });
  };

  useEffect(() => {
    if (metadata?.brand?.veevaId) {
      getContentTone();
    }
  }, [metadata?.brand?.veevaId]);

  const getAudienceMetadata = () => {
    setIsloading(true);
    getAudienceList((res, err) => {
      setIsloading(false);
      if (res) {
        setAudienceList(res.data);
        return;
      }
      showError(err);
    });
  };
  const getIndicatiosMetaData = () => {
    setIsloading(true);
    getIndicationsListFromApi((res, err) => {
      setIsloading(false);
      if (res) {
        setIndicationList(res.data);
        return;
      }
      showError(err);
    });
  };
  const getTherapeuticMetaData = () => {
    setIsloading(true);
    getTherapeuticAreaList((res, err) => {
      setIsloading(false);
      if (res) {
        setTherapeuticAreaList(res.data);
        return;
      }
      showError(err);
    });
  };

  // Store initial metadata when populated in edit mode
  useEffect(() => {
    if (editMetaDataFlag) {
      const requiredFields = [
        "moduleName",
        "brand",
        "audience",
        "segment",
        "agency",
        "language",
        "theraupaticArea",
        "draftElementIncluded",
        "communicationObjectives",
        "country",
        "topic",
      ];

      const allFieldsPresent =
        module && requiredFields.some((field) => metadata?.[field]);

      if (allFieldsPresent && !initialMetadataRef.current) {
        initialMetadataRef.current = JSON.parse(JSON.stringify(metadata));
        setIsDirty(false);
      }
    } else {
      initialMetadataRef.current = null;
      setIsDirty(false);
    }
  }, [editMetaDataFlag, module, metadata]);

  return (
    <>
      <CircularProgressBar isloading={isloading} />
      <div
        className="row ml-0 mr-0"
        style={{ marginTop: "-20px !important", borderRadius: "8px" }}
      >
        <LeftPane className="col-md-4 p-0">
          <AuthorInfo
            title="Metadata information"
            source={metadata.source}
            userName={userName}
            module={
              module
                ? moduleType === "cloned"
                  ? undefined
                  : module
                : undefined
            }
          />
        </LeftPane>
        <div
          className="col-md-8 pt-0 pr-0 pb-0 pl-0"
          // style={{ paddingBottom: "10px", paddingTop: "16px" }}
        >
          <RightPane
            metadata={metadata}
            updateMetadata={handleDropdownSelection}
            editMetaDataFlag={editMetaDataFlag}
            module={module}
            setMetadata={setMetadata}
            metaDataDropDownList={metaDataDropDownList}
            checkForEditMetadata={checkForEditMetadata}
            languageForCOuntry={languageForCOuntry}
            subTopics={subTopics}
            moduleType={moduleType}
            segmentList={segmentList}
            draftElementsList={draftElementsList}
            strategicobjList={strategicobjList}
            agencyList={agencyList}
            audienceList={audienceList}
            indicationList={indicationList}
            therapeuticAreaList={therapeuticAreaList}
            contentToneList={contentToneList}
            isModuleAvailableForUse={
              moduleType !== "cloned" &&
              module?.mlrStatus &&
              module?.mlrStatus.toLowerCase() === "available for use"
            }
          />
        </div>
      </div>
      <FooterButtons
        primaryButton={primaryButton}
        intermediateButtons={[CancelButton]}
        size="md"
      />
    </>
  );
};

const LeftPane = styled.div`
  background-color: ${variables.paleGrayColor};
  margin-top: -17px;
  //margin-left: -20px;
  border-top-left-radius: 8px;
`;

const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  padding-bottom: 2px;
  padding-top: 2px;

  img {
    width: 12px;
    height: 12px;
  }
`;

const ToolTipText = styled.div`
  font-size: 12px;
  color: #231f20;
  font-weight: 400;
`;

export default MetaDataInformation;
